module.exports = __webpack_public_path__ + "img/edit-photo.3941cc9c.png";